import React from 'react';
import { translate } from 'react-i18next';
import { Tab, Tabs } from 'react-bootstrap';
import LightingSetDataTable from './LightingSetDataTable';
import EnvelopDataTable from './EnvelopDataTable';
import AirHandlingUnitDataTable from './AirHandlingUnitDataTable';
import ACPackagedUnitDataTable from './ACPackagedUnitDataTable';
import ACSplitTypeDataTable from './ACSplitTypeDataTable';
import OtherEquipmentDataTable from './OtherEquipmentDataTable';

export class ZoneComponent extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { t, zone } = this.props;

    return (
      <Tabs
        id="zone-component-tabs"
        onSelect={key => this.setState({ tabActiveKey: key })}
        mountOnEnter={true}
      >
        <Tab eventKey={1} title={t('envelop')}>
          <EnvelopDataTable zone={zone} />
        </Tab>
        <Tab eventKey={2} title={t('lighting set')}>
          <LightingSetDataTable zoneId={zone.id} />
        </Tab>
        <Tab eventKey={3} title={t('air handling unit')}>
          <AirHandlingUnitDataTable zoneId={zone.id} />
        </Tab>
        <Tab eventKey={4} title={t('a/c packaged unit')}>
          <ACPackagedUnitDataTable zoneId={zone.id} />
        </Tab>
        <Tab eventKey={5} title={t('a/c split type')}>
          <ACSplitTypeDataTable zoneId={zone.id} />
        </Tab>
        <Tab eventKey={6} title={t('other equipments')}>
          <OtherEquipmentDataTable zoneId={zone.id} />
        </Tab>
      </Tabs>
    );
  }
}

export default translate('translations', { withRef: true })(ZoneComponent);



// WEBPACK FOOTER //
// ./src/components/zone/ZoneComponent.js